// src/components/pushMessages/NotificationToast.jsx
import React from 'react';
import { Avatar, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { NotificationsOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

export default function NotificationToast({
  title,
  body,
  iconUrl,
  timeText,
  onOpen,
  onDismiss,
  dir, // optional override; defaults to theme.direction
}) {
  const theme = useTheme();
  const direction = dir || theme.direction;

  return (
    <Paper
      // elevation={1}
      sx={{
        width: 280,
        maxWidth: '92vw',
        p: 1,
        borderRadius: 1,
        cursor: 'pointer',
        bgcolor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow:
          theme.palette.mode === 'dark'
            ? '0 12px 32px rgba(0,0,0,0.45)'
            : '0 12px 32px rgba(0,0,0,0.18)',
        direction,
      }}
      onClick={onOpen}
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <NotificationsOutlined color="primary" />

        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
            <Typography
              variant="subtitle2"
              noWrap
              sx={{ fontWeight: 600 }}
            >
              {title}
            </Typography>
            {timeText ? (
              <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                {timeText}
              </Typography>
            ) : null}
          </Stack>

          <Typography
            variant="body2"
            sx={{
              mt: 0.5,
              color: theme.palette.text.secondary,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {body}
          </Typography>

          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                onOpen?.();
              }}
              sx={{ textTransform: 'none', borderRadius: 1 }}
            >
              View
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="inherit"
              onClick={(e) => {
                e.stopPropagation();
                onDismiss?.();
              }}
              sx={{
                textTransform: 'none',
                borderRadius: 1,
                borderColor: theme.palette.divider,
              }}
            >
              Dismiss
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
}